import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { observe } from '@web/util/loading/loading';
import { route as r } from '@util/route';
import { DWS } from '@interfaces/dws';
import { WineryIntegrationsService } from '../winery-integrations.service';
import { locale } from '@util/locale';
import { IntegrationDetail } from '@interfaces/dws/integration';
import { catchError, pluck, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegrationDetailResolverService implements Resolve<IntegrationDetail[]> {
  constructor(
    private wineryIntegrationsService: WineryIntegrationsService,
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IntegrationDetail[]> {
    const integrationId = r.access(route).param('integrationId');
    // Backend expects UUID; skip non-UUID path segments (e.g. accidental /integrations/ai-agent).
    if (!integrationId || !/^[0-9a-fA-F-]{36}$/.test(integrationId)) {
      return Promise.resolve(null) as any;
    }

    const details = await observe(this.wineryIntegrationsService.getIntegrationDetails(integrationId, locale().locale))
      .pipe(
        catchError(() => of({content: []})),
        pluck('content'),
        switchMap((details?: IntegrationDetail[]) => {
          if (!details?.length)
            return this.wineryIntegrationsService.getIntegrationDetails(integrationId, 'en')
              .pipe(
                catchError(() => of({content: []})),
                pluck('content'),
              );
          else
            return of(details);
        }),
      )
      .toPromise();
    
    return Promise.resolve(details) as any;
  }
}
